export const STORAGE_KEY = {
  ACCESS_TOKEN: 'accessToken',
  EXPIRE_TOKEN: 60 * 6 * 24,
  EXPIRE_LONG_TIME: 31536000, // 365 days
  ROLE: 'role',
  ACCESS_TOKEN_REGISTER: 'accessTokenRegister',
};
